import React from "react";
import PropTypes from "prop-types";

import classes from "./styles.module.css";

const TabBarItem = ({children, label, labelColor, count, activeTab, isVisible, ...attrs}) => {

    const style = {
        display: "none"
    }

    if (activeTab === label) {
        style.display = "block"
    }

    return (
        <div className={classes.Content} style={style} {...attrs}>
            {children}
        </div>
    )
}

TabBarItem.propTypes = {
    label: PropTypes.string.isRequired,
    labelColor: PropTypes.string,
    count: PropTypes.string,
    children: PropTypes.node,
    activeTab: PropTypes.string
}

TabBarItem.defaultProps = {
    children: null,
    labelColor: '#777',
    count: null,
    activeTab: ''
}

export default TabBarItem;


// WEBPACK FOOTER //
// ./src/Components/Utils/HTabBar/TabBarItem.js